module.exports = __webpack_public_path__ + "img/tr.acce63d2.png";